export default "__VITE_ASSET__DU42PYFP__"